import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'DocumentsSearchPipe', pure: false })
export class DocumentsSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    let searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(document => {
        if (document.title) {
          return document.title.search(searchText) !== -1;
        }
      });
    }
  }
}